<template>
  <div>
    <BlocoFiltroPesquisa
      :ordenar-nomes="['Nome', 'Número Conselho']"
      :ordenar-por="['nome', 'numeroConselho']"
      :nome-do-form="nomeDoForm"
      @pesquisar="pesquisar"
      @ordenar="ordenar"
      @novo="novo"
    >
      <template #form>
        <div class="row">
          <div class="col-xs-12 col-sm-8 col-md-8 col-lg-8">
            <CampoNome :valor="filtro.nome" @atualizar="filtro.nome = $event" />
          </div>
          <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
            <CampoGenerico
              id="numeroConselho"
              label="Número do conselho"
              mascara="999999999999999"
              :valor="filtro.numeroConselho"
              @atualizar="filtro.numeroConselho = $event"
            />
          </div>
          <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
            <SelecionarSituacao
              id="ativo"
              :valor="filtro.ativo"
              @atualizar="filtro.ativo = $event"
            />
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <BlocoPaginadorPesquisa
      :total="total"
      :modo-resultado="modoResultado"
      @paginaAlterada="paginaAlterada"
      @modoAlterado="modoAlterado"
    />
    <BlocoResultadoPesquisa :total="total" :modo-resultado="modoResultado">
      <template #tabela
        ><ProfissionalTabela :profissionais="profissionais"
      /></template>
      <template #fichas>
        <div
          v-for="profissional in profissionais"
          :key="profissional._id"
          class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
        >
          <ProfissionalFicha :profissional="profissional" />
        </div>
      </template>
    </BlocoResultadoPesquisa>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import BlocoPaginadorPesquisa from '@/componentes/formulario/BlocoPaginadorPesquisa'
import BlocoResultadoPesquisa from '@/componentes/formulario/BlocoResultadoPesquisa'
import CampoGenerico from '@/componentes/formulario/CampoGenerico'
import CampoNome from '@/componentes/formulario/CampoNome'
import SelecionarSituacao from '@/componentes/formulario/SelecionarSituacao'
import { useMenu } from '@/composables/useMenu'
import { usePesquisa } from '@/composables/usePesquisa'
import ProfissionalServico from '@/servicos/ProfissionalServico'

import ProfissionalFicha from './ProfissionalFicha'
import ProfissionalTabela from './ProfissionalTabela'

export default {
  components: {
    ProfissionalFicha,
    ProfissionalTabela,
    BlocoFiltroPesquisa,
    CampoNome,
    CampoGenerico,
    SelecionarSituacao,
    BlocoResultadoPesquisa,
    BlocoPaginadorPesquisa,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const profissionais = ref([])
    const servico = new ProfissionalServico()
    const nomeResultado = 'profissionais'
    const nomeDoForm = 'ProfissionaisForm'
    const filtro = ref({
      nome: '',
      numeroConselho: '',
    })
    const pesquisa = usePesquisa({
      filtro,
      resultado: profissionais,
      servico,
      nomeResultado,
      nomeDoForm,
      cacheFormularioAtivo: true,
      onNovo: () => router.replace({ path: route.path + '/cadastro' }),
    })
    useMenu(9)
    return { profissionais, filtro, ...pesquisa }
  },
}
</script>
